import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { TrendExplorer_2Page } from "./trend-explorer-2";
import { ComponentsModule } from "../../components/components.module";

@NgModule({
  declarations: [TrendExplorer_2Page],
  imports: [IonicPageModule.forChild(TrendExplorer_2Page), ComponentsModule],
})
// tslint:disable-next-line:class-name
export class TrendExplorer_2PageModule {}



// WEBPACK FOOTER //
// ./src/pages/trend-explorer-2/trend-explorer-2.module.ts